import {Component, OnInit} from "@angular/core";
import {DatePickerInnerComponent} from "../datepicker-inner.component";

@Component({
  selector: "month-picker",
  styleUrls: [
    "./monthpicker.css"
  ],
  templateUrl: "./monthpicker.html"
})
export class MonthPickerComponent implements OnInit {
  public title: string;
  public rows: any[] = [];
  public datePicker: DatePickerInnerComponent;

  public constructor(datePicker: DatePickerInnerComponent) {
    this.datePicker = datePicker;
  }

  onSelect(dtz: any) {
    if (!dtz.disabled) {
      this.datePicker.select(dtz.date);
    }
  }

  public ngOnInit(): void {
    const self = this;

    this.datePicker.stepMonth = {years: 1};

    this.datePicker.setRefreshViewHandler(function () {
      const months: any[] = new Array(12);
      const year: number = this.activeDate.getFullYear();
      let date: Date;

      for (let i = 0; i < 12; i++) {
        date = new Date(year, i, 1);
        date = this.fixTimeZone(date);
        months[i] = this.createDateObject(date, "monthFull");
        months[i].uid = this.uniqueId + "-" + i;
      }
      // self.title = this.activeDate.toLocaleString("ru", { month: 'long' });
      self.title = this.dateFilter(this.activeDate, "year");
      self.rows = this.split(months, self.datePicker.monthColLimit);
    }, "month");

    this.datePicker.setCompareHandler(function (date1: Date, date2: Date): number {
      const d1 = new Date(date1.getFullYear(), date1.getMonth());
      const d2 = new Date(date2.getFullYear(), date2.getMonth());
      return d1.getTime() - d2.getTime();
    }, "month");

    this.datePicker.refreshView();
  }

  // todo: key events implementation
}
